<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
// import router from './router'
export default {
  name: 'App'
}
</script>

<style lang="scss">
  @import "/style/settings.scss";
  @import "/style/main.scss";

  $fonts-dir: './assets/fonts';
  @font-face {
    font-family: "Noto sans";
    font-weight: 400;
    src: url('#{$fonts-dir}/NotoSans-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: "Noto sans";
    font-weight: 700;
    src: url('#{$fonts-dir}/NotoSans-Bold.ttf') format('truetype');
  }
  @font-face {
    font-family: "Roboto Mono";
    font-weight: 400;
    src:
      url('#{$fonts-dir}/RobotoMono-Regular.ttf') format('truetype');
  }
  @font-face {
    font-family: "Roboto Mono";
    font-weight: 400;
    font-style: italic;
    src:
      url('#{$fonts-dir}/RobotoMono-Italic.ttf') format('truetype');
  }
  @font-face {
    font-family: "Roboto Mono";
    font-weight: 700;
    src:
      url('#{$fonts-dir}/RobotoMono-Bold.ttf') format('truetype');
  }
  @font-face {
    font-family: "Roboto Mono";
    font-weight: 700;
    font-style: italic;
    src:
      url('#{$fonts-dir}/RobotoMono-BoldItalic.ttf') format('truetype');
  }
</style>



// WEBPACK FOOTER //
// src/App.vue